import { FlexDiv } from '@/app/shared/common.StyledComponents';
import { CompanyLogoStandard } from '@/app/shared/components/CompanyLogo';
import { useShowDebtorPortalComponents } from '@/app/shared/hooks/useShowDebtorPortalComponents';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { HeaderAppName } from './HeaderAppName';
import HeaderLogo from './HeaderLogo';
import UserProfile from './UserProfile';
import { PageRoutes } from '@/app/components/router/routes';
import { DebtorSwitcherContainer } from '../DebtorSwitcher/DebtorSwitcherContainer';

const HeaderWrapper = styled(FlexDiv)`
  width: 100%;
  height: ${rem(64)};
  background: ${({ theme }: any) => theme.colors.background};
  align-items: center;
  justify-content: space-between;
`;

const LogoContainer = styled(FlexDiv)`
  gap: ${rem(10)};
  padding: ${rem(12)} ${rem(24)};
  & > div {
    width: auto;
  }
`;

const StandardLogoContainer = styled.div<{
  isFaasClient?: boolean;
}>`
  * > img {
    width: ${({ isFaasClient }) => (isFaasClient ? rem(117) : '100%')};
  }
`;

const RightSideContainer = styled(FlexDiv)`
  align-items: center;
  gap: ${rem(16)};
  padding-right: ${rem(24)};
`;

const CenterContainer = styled(FlexDiv)`
  flex: 1;
  justify-content: center;
  padding: 0 ${rem(24)};
  max-width: ${rem(500)};
`;

export const GlobalHeader = () => {
  const showDebtorPortalComponents = useShowDebtorPortalComponents();

  const logoUrl = showDebtorPortalComponents
    ? PageRoutes.DASHBOARD
    : window.location.href;

  return (
    <HeaderWrapper>
      <HeaderLogo url={logoUrl}>
        <LogoContainer>
          <StandardLogoContainer>
            <CompanyLogoStandard size={187.5} />
          </StandardLogoContainer>
        </LogoContainer>
      </HeaderLogo>
      {showDebtorPortalComponents && (
        <CenterContainer>
          <DebtorSwitcherContainer />
        </CenterContainer>
      )}
      <RightSideContainer>
        {showDebtorPortalComponents && (
          <>
            <HeaderAppName />
            <UserProfile />
          </>
        )}
      </RightSideContainer>
    </HeaderWrapper>
  );
};